import { PropsWithChildren } from 'react'
import Main from './Main'
import Card from './Card'
import { Skeleton } from '@/components/ui/skeleton'

interface Props {
  title: string
  description?: string
  loading?: boolean
}

const LandingPage = ({
  title,
  description,
  loading,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Main title={title} description={description}>
      <div className='max-w-4xl mx-auto'>
        <h1 className='mb-4'>{title}</h1>
        {loading ? <Skeleton className='h-[150vh]' /> : <Card>{children}</Card>}
      </div>
    </Main>
  )
}

export default LandingPage
